// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".video-modal-enter-active[data-v-1b66a0a2]{transition:opacity .3s ease-out}.video-modal-leave-active[data-v-1b66a0a2]{transition:opacity .2s ease-in}.video-modal-enter-from[data-v-1b66a0a2]{opacity:0}.video-modal-enter-to[data-v-1b66a0a2],.video-modal-leave-from[data-v-1b66a0a2]{opacity:1}.video-modal-leave-to[data-v-1b66a0a2]{opacity:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
